/* unplugin-vue-components disabled */var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.block)?_c('code',{class:_vm.modeClass},[_vm._t("default")],2):_c('pre',{class:_vm.modeClass},[_vm._v("  "),_vm._t("default"),_vm._v("\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }